import { buildGlobalReferenceContext } from '../../../context/buildGlobalReferenceContext.mjs';

const [DropdownGroupContextProvider, useDropdownGroupContext] = buildGlobalReferenceContext("Dropdown.Group");

export { DropdownGroupContextProvider, useDropdownGroupContext };
//# sourceMappingURL=group-context.mjs.map
